module.exports = __webpack_public_path__ + "static/logo3-b37034a4907b9d300e80c1b368ea4b24.jpg";